import { common } from './ZH-TW/common';
import { announce } from './ZH-TW/announce'
import { mail } from './ZH-TW/mail'
import { sysop } from './ZH-TW/sysop'
import { flow } from './ZH-TW/flow';
import { eForm } from './ZH-TW/eForm';
import { sample } from './ZH-TW/sample';

export default {
    translation: {
        'common': common,
        'announce': announce,
        'mail': mail,
        'sysop': sysop,
        'flow': flow,
        'eForm': eForm,
        'sample': sample
    }
};
